<template>
    <div class="container">
        <h2 class="text-start offset-md-2 offset-1 mt-3 fw-bold">POVPRAŠEVANJE</h2>
        <ContactForm/>
        <h2 class="text-start offset-md-2 offset-1 mt-3 fw-bold">KONTAKT</h2>
        <div class="d-flex justify-content-center mb-2">
            <div class="row m-3 text-start w-custom">
                <div class="col-md-6 mt-3">
                    <div class="card d-flex justify-content-center">
                        <img src="../images/person.png" class="card-img-top" width="100%">
                        <div class="card-body">
                            <h5 class="card-title fw-bold">Jože Topler</h5>
                            <p class="card-text"><span class="fw-bold">Direktor</span><br>T: 041-712-780 <br> E: joze@avtoprevoznistvo-topler.eu</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mt-3">
                    <div class="card d-flex justify-content-center">
                        <img src="../images/person.png" class="card-img-top" width="100%">
                        <div class="card-body">
                            <h5 class="card-title fw-bold">Matic Mori</h5>
                            <p class="card-text"><span class="fw-bold">Prokurist</span><br>T: 041-434-356 <br> E: matic@avtoprevoznistvo-topler.eu</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContactForm from '../components/ContactForm.vue'

export default {
    name: "Contact",
    components:{
        ContactForm
    }
};
</script>